/**
 * HiNooki v8 conversion safeguards.
 * Confirms a successful cart/add response before the theme's slower cart
 * refresh finishes, so customers receive immediate feedback.
 */
(() => {
  if (window.__hnCroV8FetchInstalled) return;
  window.__hnCroV8FetchInstalled = true;

  const nativeFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);

    try {
      const request = args[0];
      const url = typeof request === 'string' ? request : request?.url;
      const pathname = new URL(url, window.location.origin).pathname;
      const addPath = new URL(theme.routes.cart_add_url, window.location.origin).pathname;

      if (pathname === addPath && response.ok) {
        response.clone().json().then((payload) => {
          if (!payload?.status) {
            document.dispatchEvent(new CustomEvent('ajaxProduct:accepted', {
              detail: { product: payload }
            }));
          }
        }).catch(() => {});
      }
    } catch (error) {
      // Never interrupt the native cart request if the enhancement cannot run.
    }

    return response;
  };
})();
